export default __webpack_public_path__ + "static/media/Button - Icon (2).be86b464.svg";